import React from 'react';
import DataTableChart, { DataTableChartProps, TableColumnDef } from './DataTableChart';

const DEFAULT_COLUMNS: TableColumnDef[] = [
    { key: 'metric', label: 'Metric', emphasis: 'primary' },
    { key: 'current', label: 'Current', align: 'right' },
    { key: 'previous', label: 'Previous', align: 'right' },
    { key: 'change', label: 'Change', align: 'right', emphasis: 'strong' },
];

const DEFAULT_ROWS: Record<string, unknown>[] = [
    { metric: 'Total Orders', current: '6,214', previous: '5,890', change: '+5.5%' },
    { metric: 'Gross Revenue', current: 'Rs. 4.20M', previous: 'Rs. 3.98M', change: '+5.5%' },
    { metric: 'Avg Order Value', current: 'Rs. 676', previous: 'Rs. 675', change: '+0.1%' },
    { metric: 'Fulfillment Rate', current: '85.77%', previous: '84.12%', change: '+1.65pp' },
    { metric: 'Active Customers', current: '3,749', previous: '3,612', change: '+3.8%' },
];

const MetricsTableChart: React.FC<DataTableChartProps> = (props) => {
    const columns = props.data?.columns;
    const rows = props.data?.rows;

    const data = {
        columns: columns && columns.length > 0 ? columns : DEFAULT_COLUMNS,
        rows: Array.isArray(rows) && rows.length > 0 ? rows : DEFAULT_ROWS,
    };
    
    const options = {
        variant: props.options?.variant ?? 'report',
        striped: props.options?.striped ?? true,
        maxRows: props.options?.maxRows,
        emptyMessage: props.options?.emptyMessage,
    };

    return <DataTableChart {...props} data={data} options={options} />;
};

export default MetricsTableChart;
